/*
 * @Author: ken yang
 * @Date: 2022-11-08 19:13:02
 * @LastEditTime: 2022-11-09 11:57:44
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/utils/directive/noNums.js
 */
const noNums = (el, binding) => {
  const content = el.innerText
  if (content === null || content === '') {
    var para = document.createElement('p')
    para.setAttribute('class', 'linshi')
    para.innerHTML = '--'
    el.appendChild(para)
  } else {
    const dom = el.getElementsByClassName('linshi')[0]
    if (dom)el.removeChild(dom)
    el.style.display = 'block'
  }
}
export default noNums
